// Module
var code = "<ul class=\"customizer-features\"> <li class=\"customizer-features__feature\" ng-repeat=\"feature in $ctrl.features | limitTo:4\" title=\"{{::feature.text}}\"> <i class=\"material-icons-outlined\">check_circle</i> <span class=\"ml-1\">{{feature.header}}</span> </li> </ul>";
// Exports
module.exports = code;